import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CertificationBadges = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const certificationCategories = [
    { id: 'all', name: 'All Certifications', count: 19 },
    { id: 'development', name: 'Development', count: 6 },
    { id: 'marketing', name: 'Marketing & Analytics', count: 10 },
    { id: 'devops', name: 'DevOps', count: 1 },
    { id: 'mobile', name: 'Mobile Development', count: 1 },
    { id: 'ai', name: 'AI & Ethics', count: 1 }
  ];

  const certifications = [
    // Google Skillshop certificates (requested order with this one first)
    {
      id: 10,
      name: 'Google Skillshop Certification',
      issuer: 'Google Skillshop',
      category: 'marketing',
      level: 'Associate',
      dateEarned: null,
      expiryDate: null,
      credentialId: '2d4f565c-ffe2-4ae4-8b4d-3b1fb5100604',
      verificationUrl: 'https://skillshop.credential.net/2d4f565c-ffe2-4ae4-8b4d-3b1fb5100604#acc.8Uoc92T4',
      badge: 'https://cdn.simpleicons.org/google/4285F4',
      badgeAlt: 'Google logo',
      skills: ['Google Ads', 'Optimization', 'Measurement'],
      description: 'Google Skillshop certification. Details available on verification page.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 11,
      name: 'Google Analytics Certification',
      issuer: 'Google Skillshop',
      category: 'marketing',
      level: 'Associate',
      dateEarned: '2025-09-30',
      expiryDate: '2026-09-30',
      credentialId: 'f6b844b9-7a98-41bf-8cc6-659e050054ae',
      verificationUrl: 'https://skillshop.credential.net/f6b844b9-7a98-41bf-8cc6-659e050054ae#acc.dGUjfwXa',
      badge: 'https://cdn.simpleicons.org/googleanalytics/E37400',
      badgeAlt: 'Google Analytics logo',
      skills: ['GA4', 'Measurement', 'Reporting'],
      description: 'Demonstrates GA4 property setup, data collection, and reporting mastery.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 12,
      name: 'AI-Powered Performance Ads Certification',
      issuer: 'Google Skillshop',
      category: 'marketing',
      level: 'Associate',
      dateEarned: '2025-09-30',
      expiryDate: '2026-09-30',
      credentialId: 'da103005-0cbb-4cd4-8edf-4bd8c1d8b00e',
      verificationUrl: 'https://skillshop.credential.net/da103005-0cbb-4cd4-8edf-4bd8c1d8b00e#acc.6eEgcVAO',
      badge: 'https://cdn.simpleicons.org/googleads/4285F4',
      badgeAlt: 'Google Ads logo',
      skills: ['AI Automation', 'Cross-Channel Ads', 'Optimization'],
      description: 'Covers AI-driven Google Ads strategy, automation, and insights.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 13,
      name: 'Grow Offline Sales Certification',
      issuer: 'Google Skillshop',
      category: 'marketing',
      level: 'Associate',
      dateEarned: '2025-09-30',
      expiryDate: '2026-09-30',
      credentialId: '19fbbef3-1280-42d8-82cc-d7d8ee19ec35',
      verificationUrl: 'https://skillshop.credential.net/19fbbef3-1280-42d8-82cc-d7d8ee19ec35#acc.basY1F5J',
      badge: 'https://cdn.simpleicons.org/googleads/4285F4',
      badgeAlt: 'Google Ads logo',
      skills: ['Offline Sales', 'Performance Max', 'Measurement'],
      description: 'Validates offline sales strategy and Performance Max for store goals.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 14,
      name: 'Campaign Manager 360 Certification Exam',
      issuer: 'Google Skillshop',
      category: 'marketing',
      level: 'Associate',
      dateEarned: '2025-09-30',
      expiryDate: '2026-09-30',
      credentialId: '2ca92a7a-2799-4fec-b906-ee192f9831a0',
      verificationUrl: 'https://skillshop.credential.net/2ca92a7a-2799-4fec-b906-ee192f9831a0#acc.1qkxzBwU',
      badge: 'https://cdn.simpleicons.org/googlemarketingplatform/1A73E8',
      badgeAlt: 'Google Marketing Platform logo',
      skills: ['Trafficking', 'Tagging', 'Reporting'],
      description: 'Covers planning, trafficking, and reporting with Campaign Manager 360.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 15,
      name: 'Google Skillshop Certification',
      issuer: 'Google Skillshop',
      category: 'marketing',
      level: 'Associate',
      dateEarned: null,
      expiryDate: null,
      credentialId: '4759a3aa-a718-4838-a6f2-97fe324b6f00',
      verificationUrl: 'https://skillshop.credential.net/4759a3aa-a718-4838-a6f2-97fe324b6f00#acc.wBs0xeqa',
      badge: 'https://cdn.simpleicons.org/google/4285F4',
      badgeAlt: 'Google logo',
      skills: ['Google Ads', 'Optimization'],
      description: 'Google Skillshop certification. Details available on verification page.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 16,
      name: 'Google Skillshop Certification',
      issuer: 'Google Skillshop',
      category: 'marketing',
      level: 'Associate',
      dateEarned: null,
      expiryDate: null,
      credentialId: '62b1ade2-8612-4165-8f98-65c0a70955ab',
      verificationUrl: 'https://skillshop.credential.net/62b1ade2-8612-4165-8f98-65c0a70955ab#acc.B62cLCRU',
      badge: 'https://cdn.simpleicons.org/google/4285F4',
      badgeAlt: 'Google logo',
      skills: ['Google Ads', 'Optimization'],
      description: 'Google Skillshop certification. Details available on verification page.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 17,
      name: 'Google Skillshop Certification',
      issuer: 'Google Skillshop',
      category: 'marketing',
      level: 'Associate',
      dateEarned: null,
      expiryDate: null,
      credentialId: '04fb68b6-486e-4bff-86f5-29864f8894f6',
      verificationUrl: 'https://skillshop.credential.net/04fb68b6-486e-4bff-86f5-29864f8894f6#acc.mBAxbaIr',
      badge: 'https://cdn.simpleicons.org/google/4285F4',
      badgeAlt: 'Google logo',
      skills: ['Google Ads', 'Optimization'],
      description: 'Google Skillshop certification. Details available on verification page.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 18,
      name: 'Google Skillshop Certification',
      issuer: 'Google Skillshop',
      category: 'marketing',
      level: 'Associate',
      dateEarned: null,
      expiryDate: null,
      credentialId: '5d01c961-aea3-415c-ae4e-99df88fc9232',
      verificationUrl: 'https://skillshop.credential.net/5d01c961-aea3-415c-ae4e-99df88fc9232#acc.4ieIdBDS',
      badge: 'https://cdn.simpleicons.org/google/4285F4',
      badgeAlt: 'Google logo',
      skills: ['Google Ads', 'Optimization'],
      description: 'Google Skillshop certification. Details available on verification page.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 19,
      name: 'Google Skillshop Certification',
      issuer: 'Google Skillshop',
      category: 'marketing',
      level: 'Associate',
      dateEarned: null,
      expiryDate: null,
      credentialId: '9fd5eaf4-26e0-485a-8766-4a4692a2d74d',
      verificationUrl: 'https://skillshop.credential.net/9fd5eaf4-26e0-485a-8766-4a4692a2d74d#acc.gjPHKuLY',
      badge: 'https://cdn.simpleicons.org/google/4285F4',
      badgeAlt: 'Google logo',
      skills: ['Google Ads', 'Optimization'],
      description: 'Google Skillshop certification. Details available on verification page.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 1,
      name: 'Full Stack Open',
      issuer: 'University of Helsinki',
      category: 'development',
      level: 'Professional',
      dateEarned: '2025-10-01',
      expiryDate: null,
      credentialId: '05c08a72413e62f48fd8ced3d1346bc8',
      verificationUrl: 'https://studies.cs.helsinki.fi/stats/api/certificate/fullstackopen/en/05c08a72413e62f48fd8ced3d1346bc8',
  badge: "https://cdn.simpleicons.org/react/61DAFB",
  badgeAlt: 'React logo',
      skills: ['React', 'Node.js', 'GraphQL', 'MongoDB', 'Testing', 'TypeScript'],
      description: 'Comprehensive full stack web development course covering React, Node.js, GraphQL, and testing. Grade: 5/5. 7 ECTS credits.',
      status: 'active',
      difficulty: 'Advanced'
    },
    {
      id: 2,
      name: 'Full Stack Open - TypeScript',
      issuer: 'University of Helsinki',
      category: 'development',
      level: 'Associate',
      dateEarned: '2025-10-01',
      expiryDate: null,
      credentialId: 'fs-typescript',
      verificationUrl: 'https://studies.cs.helsinki.fi/stats/courses/fs-typescript',
      badge: "https://cdn.simpleicons.org/typescript/3178C6",
      badgeAlt: 'TypeScript logo',
      skills: ['TypeScript', 'Types', 'Generics', 'Type-Safe React'],
      description: 'TypeScript module of Full Stack Open course. Strongly-typed full stack development. 1 ECTS credit.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 3,
      name: 'Full Stack Open - GraphQL',
      issuer: 'University of Helsinki',
      category: 'development',
      level: 'Associate',
      dateEarned: '2025-10-01',
      expiryDate: null,
      credentialId: 'a026a126830407d4d7d42ff2c2679776',
      verificationUrl: 'https://studies.cs.helsinki.fi/stats/api/certificate/fs-graphql/en/a026a126830407d4d7d42ff2c2679776',
  badge: "https://cdn.simpleicons.org/graphql/E10098",
  badgeAlt: 'GraphQL logo',
      skills: ['GraphQL', 'API Development', 'Apollo Server', 'Schema Design'],
      description: 'GraphQL module of Full Stack Open course. Building efficient, flexible APIs using GraphQL. 1 ECTS credit.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 9,
      name: 'Full Stack Open - Relational Databases',
      issuer: 'University of Helsinki',
      category: 'development',
      level: 'Associate',
      dateEarned: '2025-10-01',
      expiryDate: null,
      credentialId: 'a1de6f8d2d0000713f83df27e8640dea',
      verificationUrl: 'https://studies.cs.helsinki.fi/stats/api/certificate/fs-psql/en/a1de6f8d2d0000713f83df27e8640dea',
      badge: "https://cdn.simpleicons.org/postgresql/4169E1",
      badgeAlt: 'PostgreSQL logo',
      skills: ['PostgreSQL', 'SQL', 'Relational Modeling', 'Schema Design', 'Indexes'],
      description: 'Relational Databases module of Full Stack Open (PostgreSQL). Structured data, SQL, and schema design. 1 ECTS credit.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 4,
      name: 'Full Stack Open - CI/CD',
      issuer: 'University of Helsinki',
      category: 'devops',
      level: 'Associate',
      dateEarned: '2025-10-01',
      expiryDate: null,
      credentialId: '71fb76a703baeddb895fcb2075ea4570',
      verificationUrl: 'https://studies.cs.helsinki.fi/stats/api/certificate/fs-cicd/en/71fb76a703baeddb895fcb2075ea4570',
  badge: "https://cdn.simpleicons.org/githubactions/2088FF",
  badgeAlt: 'GitHub Actions logo',
      skills: ['CI/CD', 'GitHub Actions', 'Automated Testing', 'Deployment Pipelines'],
      description: 'CI/CD module of Full Stack Open course. Automated software delivery pipelines and DevOps practices. 1 ECTS credit.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 5,
      name: 'Full Stack Open - React Native',
      issuer: 'University of Helsinki',
      category: 'mobile',
      level: 'Associate',
      dateEarned: '2025-10-01',
      expiryDate: null,
      credentialId: '5a5ca336593b972f8db79c573c34de55',
      verificationUrl: 'https://studies.cs.helsinki.fi/stats/api/certificate/fs-react-native-2020/en/5a5ca336593b972f8db79c573c34de55',
  badge: "https://cdn.simpleicons.org/react/61DAFB",
  badgeAlt: 'React logo',
      skills: ['React Native', 'Mobile Development', 'Cross-Platform Apps', 'JavaScript'],
      description: 'React Native module of Full Stack Open course. Building cross-platform mobile applications. 2 ECTS credits.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 6,
      name: 'Java Programming I',
      issuer: 'University of Helsinki',
      category: 'development',
      level: 'Associate',
      dateEarned: '2025-08-01',
      expiryDate: null,
      credentialId: 'qhpg15d1gkl',
      verificationUrl: 'https://certificates.mooc.fi/validate/qhpg15d1gkl',
  badge: "https://pngset.com/images/java-logo-image-symbol-trademark-ketchup-food-transparent-png-1949390.png",
  badgeAlt: 'Java logo',
      skills: ['Java', 'Object-Oriented Programming', 'Algorithms', 'Data Structures'],
      description: 'Comprehensive Java programming fundamentals course from University of Helsinki. 5 ECTS credits.',
      status: 'active',
      difficulty: 'Intermediate'
    },
    {
      id: 7,
      name: 'Java Programming II',
      issuer: 'University of Helsinki',
      category: 'development',
      level: 'Associate',
      dateEarned: '2025-09-01',
      expiryDate: null,
      credentialId: '8bab5wi0yot',
      verificationUrl: 'https://certificates.mooc.fi/validate/8bab5wi0yot',
  badge: "https://pngset.com/images/java-logo-image-symbol-trademark-ketchup-food-transparent-png-1949390.png",
  badgeAlt: 'Java logo',
      skills: ['Advanced Java', 'Collections', 'File I/O', 'Exception Handling'],
      description: 'Advanced Java programming course covering complex topics from University of Helsinki. 5 ECTS credits.',
      status: 'active',
      difficulty: 'Advanced'
    },
    {
      id: 8,
      name: 'Ethics of AI',
      issuer: 'University of Helsinki',
      category: 'ai',
      level: 'Associate',
      dateEarned: '2025-10-14',
      expiryDate: null,
      credentialId: 'ai-ethics-cert',
      verificationUrl: 'https://certificates.mooc.fi/validate/ai-ethics-cert',
  badge: "https://cdn.simpleicons.org/bookstack/0288D1",
  badgeAlt: 'BookStack logo',
      skills: ['AI Ethics', 'Responsible AI', 'AI Policy', 'Ethical Decision Making'],
      description: 'Explores ethical dimensions of artificial intelligence. Endorsed by FCAI, HIDATA, and cities of Amsterdam and London. 2 ECTS credits.',
      status: 'active',
      difficulty: 'Intermediate'
    }
  ];

  const filteredCertifications = React.useMemo(() => {
    if (selectedCategory === 'all') {
      const list = certifications?.slice() ?? [];
      // Put Google/marketing certs at the bottom while keeping others at the top
      list.sort((a, b) => (a?.category === 'marketing') - (b?.category === 'marketing'));
      return list;
    }
    return certifications?.filter((cert) => cert?.category === selectedCategory);
  }, [selectedCategory, certifications]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'text-success';
      case 'expiring': return 'text-warning';
      case 'expired': return 'text-destructive';
      default: return 'text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active': return 'CheckCircle';
      case 'expiring': return 'AlertTriangle';
      case 'expired': return 'XCircle';
      default: return 'Circle';
    }
  };

  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case 'Expert': return 'bg-red-500';
      case 'Advanced': return 'bg-orange-500';
      case 'Intermediate': return 'bg-blue-500';
      case 'Beginner': return 'bg-green-500';
      default: return 'bg-slate-500';
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const isExpiringSoon = (expiryDate) => {
    const today = new Date();
    const expiry = new Date(expiryDate);
    const diffTime = expiry - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 90 && diffDays > 0;
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-bold text-foreground">Certification Badges</h3>
          <p className="text-muted-foreground">Professional certifications and achievements</p>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Award" size={20} color="var(--color-primary)" />
          <span className="text-sm text-muted-foreground">{certifications?.length} certifications</span>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-6">
        {certificationCategories?.map((category) => (
          <button key={category?.id} onClick={() => setSelectedCategory(category?.id)} className={`flex items-center space-x-2 px-4 py-2 rounded-lg border transition-all ${selectedCategory === category?.id ? 'border-primary bg-primary/10 text-primary' : 'border-border hover:border-muted-foreground text-muted-foreground hover:text-foreground'}`}>
            <span className="text-sm font-medium">{category?.name}</span>
            <span className="text-xs bg-muted px-2 py-1 rounded-full">{category?.count}</span>
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {filteredCertifications?.map((cert) => (
          <div key={cert?.id} className="group bg-muted/30 border border-border rounded-xl p-6 hover:border-primary/50 hover:bg-primary/5 transition-all">
            <div className="flex items-start space-x-4 mb-4">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-background border border-border rounded-lg overflow-hidden p-1.5">
                  <Image src={cert?.badge} alt={cert?.badgeAlt} className="w-full h-full object-contain" />
                </div>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between mb-2">
                  <h4 className="font-semibold text-foreground text-lg leading-tight">{cert?.name}</h4>
                  <div className="flex items-center space-x-1">
                    <Icon name={getStatusIcon(cert?.status)} size={16} className={getStatusColor(cert?.status)} />
                  </div>
                </div>

                <p className="text-sm text-muted-foreground mb-2">{cert?.issuer}</p>

                <div className="flex items-center space-x-2 mb-3">
                  <span className={`px-2 py-1 text-xs rounded-full ${getDifficultyColor(cert?.difficulty)} bg-opacity-20 text-foreground font-medium`}>{cert?.difficulty}</span>
                  <span className="px-2 py-1 text-xs rounded-full bg-muted text-muted-foreground">{cert?.level}</span>
                  {isExpiringSoon(cert?.expiryDate) && <span className="px-2 py-1 text-xs rounded-full bg-warning/20 text-warning font-medium">Expiring Soon</span>}
                </div>
              </div>
            </div>

            <p className="text-sm text-muted-foreground mb-4">{cert?.description}</p>

            <div className="space-y-3 mb-4">
              <div>
                <span className="text-xs text-muted-foreground mb-1 block">Skills Validated:</span>
                <div className="flex flex-wrap gap-1">
                  {cert?.skills?.map((skill, index) => (
                    <span key={index} className="px-2 py-1 bg-primary/10 text-primary text-xs rounded font-mono">{skill}</span>
                  ))}
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4 text-xs">
                <div>
                  <span className="text-muted-foreground block">Earned:</span>
                  <span className="text-foreground font-medium">{formatDate(cert?.dateEarned)}</span>
                </div>
                <div>
                  <span className="text-muted-foreground block">Expires:</span>
                  <span className="text-foreground font-medium">{cert?.expiryDate ? formatDate(cert?.expiryDate) : 'No expiry'}</span>
                </div>
              </div>

              <div>
                <span className="text-muted-foreground text-xs block mb-1">Credential ID:</span>
                <span className="text-foreground font-mono text-xs">{cert?.credentialId}</span>
              </div>
            </div>

            <div className="flex items-center justify-between pt-4 border-t border-border">
              <a href={cert?.verificationUrl} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-primary hover:text-primary/80 transition-colors">
                <Icon name="ExternalLink" size={14} />
                <span className="text-sm font-medium">Verify Certificate</span>
              </a>

              <button className="flex items-center space-x-2 text-muted-foreground hover:text-foreground transition-colors">
                <Icon name="Download" size={14} />
                <span className="text-sm">Download</span>
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 pt-6 border-t border-border">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="text-center">
            <div className="text-2xl font-bold text-foreground">{certifications?.length}</div>
            <div className="text-sm text-muted-foreground">Total Certifications</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-foreground">{certifications?.filter((cert) => cert?.status === 'active')?.length}</div>
            <div className="text-sm text-muted-foreground">Active</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-foreground">{certifications?.filter((cert) => isExpiringSoon(cert?.expiryDate))?.length}</div>
            <div className="text-sm text-muted-foreground">Expiring Soon</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-foreground">{new Date()?.getFullYear()}</div>
            <div className="text-sm text-muted-foreground">Latest Year</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificationBadges;
